// extracted by mini-css-extract-plugin
module.exports = {"disabledLink":"NamedLink_disabledLink__2jatS"};